import {LandingRoutes} from "../../../routes/LandingRoutes"
import styles from "./index.module.scss"
import {NavBar} from "../NavBar"

export const LandingContainer = () => {
  return (
    <div className={styles.Container}>
      <div className={styles.NavBar}>
        <NavBar/>
      </div>
      <div className={styles.Route}>
        <LandingRoutes/>
      </div>
    </div>
  )
}
